export const environment = {
  production: false,
  URL_API: 'https://partes-backend.infoprec.com',
  // URL_API: 'https://ip0003-backend.webpisolutions.com',
  firebaseConfig: {
    apiKey: "AIzaSyBBRZyUaesotDU85SBqWue52BL_UFZL3xc",
    authDomain: "ip-0003-dev.firebaseapp.com",
    projectId: "ip-0003-dev",
    storageBucket: "ip-0003-dev.firebasestorage.app",
    messagingSenderId: "900755488762",
    appId: "1:900755488762:web:2020ab876edf9a40296e43",
    measurementId: "G-9QYZ7GD5J1"
  }
};